import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { AssuranceService } from "../../core/service/assurance.service";
import { Assurance } from "../../core/model/assurance";

@Component({
  selector: "app-edit-assurance",
  templateUrl: "./edit-assurance.component.html",
  styleUrls: ["./edit-assurance.component.scss"],
})
export class EditAssuranceComponent implements OnInit {
  @Input()
  set assurance(value: Assurance) {
    if (value) {
      this._assurance = { ...value };
      this.loading = false;
      this.cdr.detectChanges();
    }
  }
  get assurance(): Assurance {
    return this._assurance;
  }

  private _assurance: Assurance;

  form2: FormGroup;
  pressButton: Boolean = false;
  loading = true;

  constructor(
    private _assuranceService: AssuranceService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this._assuranceService
      .update(this.assurance)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          this.activeModal.close(this.assurance);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
